import React from "react";
import { Link } from "react-router-dom";
import Button from "../ui/Button";
import { useCart } from "../../context/CartContext";

export default function ProductCard({ product }) {
  const { addToCart } = useCart();

  return (
    <div className="group bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-sm transition-all duration-300 hover:-translate-y-2 hover:shadow-xl min-h-[430px] flex flex-col">
      <Link to={`/product/${product.id}`}>
        {/* Bigger image area */}
        <div className="h-80 bg-slate-50 overflow-hidden">
          <img
            src={product.images?.[0]}
            alt={product.name}
            className="w-full h-full object-cover scale-[1.15] transition-transform duration-300 group-hover:scale-[1.22]"
          />
        </div>
      </Link>

      {/* Bottom section pushed lower */}
      <div className="relative px-5 pt-5 pb-8 flex-1">
        {/* Name + Price */}
        <div className="flex items-start justify-between gap-4">
          <Link to={`/product/${product.id}`} className="flex-1">
            <h3 className="text-[15px] font-semibold text-slate-900 hover:text-slate-700 leading-snug">
              {product.name}
            </h3>
          </Link>

          <div className="text-[15px] font-semibold text-slate-900 whitespace-nowrap">
            ${product.price}
          </div>
        </div>

        {/* Hover buttons slide up */}
        <div className="absolute left-0 right-0 bottom-0 px-5 pb-5 opacity-0 translate-y-3 transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0">
          <div className="flex gap-2">
            <Button
              variant="secondary"
              className="w-full"
              onClick={() => addToCart(product, 1)}
            >
              Add to cart
            </Button>

            <Link to={`/product/${product.id}`} className="w-full">
              <Button className="w-full">View</Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
